import { apiAiAssistant } from "@/api/ai-assistant.api.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const aiAssistantKeys = createQueryKeys("aiAssistant", {
  threads: null,
  thread: (id: number) => [id],
});

export const useAiAssistantThreads = () => {
  return useQuery({
    ...aiAssistantKeys.threads,
    queryFn: async ({ signal }) => {
      const result = await apiAiAssistant.getThreads(signal);
      if (result.error || !result.data) throw new ApiErrorException(result.error);
      return result.data;
    },
  });
};

export const useAiAssistantThread = (id: number) => {
  return useQuery({
    ...aiAssistantKeys.thread(id),
    queryFn: async ({ signal }) => {
      const result = await apiAiAssistant.getThread(id, signal);
      if (result.error || !result.data) throw new ApiErrorException(result.error);
      return result.data;
    },
    // Сообщения из кэша стали бы начальными для useChat без ходов, сделанных после прошлого открытия.
    gcTime: 0,
  });
};

export const useAiAssistantThreadDelete = () => {
  const queryClient = useQueryClient();
  const { onError } = useErrorHandle();

  return useMutation({
    mutationFn: async (id: number) => {
      const result = await apiAiAssistant.deleteThread(id);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: aiAssistantKeys.threads.queryKey });
    },
    onError: (error: Error) => {
      onError(error);
    },
  });
};
